import { useCallback } from 'react'

import { Result, AuthenticationResponse } from '~/redux/apis/types'
import { useAppDispatch } from '~/redux/hooks'
import { LoginType } from '~/analytics/account/accountEvents.types'

import { loginUser } from '../slices/auth.slice'

interface ParamType {
  loginType: LoginType
  result: Result<AuthenticationResponse>
}

export default function useLoginUser(): (params: ParamType) => void {
  const dispatch = useAppDispatch()

  const AddUserSession = useCallback(
    (params: ParamType): void => {
      dispatch(loginUser(params))
    },
    [dispatch],
  )

  return AddUserSession
}
